export default __webpack_public_path__ + "static/media/sentenceswarmup_locked.99fe2e8b.svg";